import React from 'react'
import { ItemTextView } from './item-text.view'
import { IItemText } from './item-text.types'

export function ItemText({...props}: IItemText) {
	return (<ItemTextView {...props} />)
}
